'use client';

import { appRouterSsrErrorHandler, AppRouterErrorProps } from '@highlight-run/next/ssr';
import { Button } from "@/components/ui/button";
import { TriangleAlertIcon } from "lucide-react";
import Link from "next/link";


export default appRouterSsrErrorHandler(({ reset }: AppRouterErrorProps) => {
  return (
    <main className="flex-1 w-full flex flex-col items-center justify-center px-4">
      <div className="flex items-center justify-center w-20 h-20 rounded-full bg-muted mb-6">
        <TriangleAlertIcon className="w-10 h-10 text-destructive" />
      </div>
      <h1 className="text-4xl font-bold mb-2">An unexpected error occurred</h1>
      <p className="text-muted-foreground mb-6">
        Sorry, there was problem processing your request. Please try again later.
      </p>
      <div className="flex gap-4">
        <Link href="/">
          <Button variant="link" size="lg">
            Go back home
          </Button>
        </Link>
        <Button variant="default" size="lg" onClick={reset}>
          Try again
        </Button>
      </div>
    </main>
  );
})
